import { Card, Container, CardHeader, Divider, CardContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import Page from 'src/components/Page';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }
}));

function StockAction() {
  const classes = useStyles();


  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Rapor ekranı" />
          <Divider />
          <CardContent>
            Yapım Aşamasında...
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}

export default StockAction;
